import React, { useState, useEffect } from "react";
import styles from "./FolderSelectorModal.module.css";
import { MyIcons } from "../icons/my-icons";
import Button from "../ui/button";
import Input from "../ui/input";
import { API_BASE_URL } from "../../config";

const FolderSelectorModal = ({ isOpen, onClose, onFolderSelect, expId }) => {
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showCreateNew, setShowCreateNew] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");

  // Cargar carpetas del SAMBA
  useEffect(() => {
    if (!isOpen) return;

    async function fetchFolders() {
      setLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem('authToken');
        const url = `${API_BASE_URL}/archivos/${expId}`;
        
        const res = await fetch(url, {
          headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        });
        
        if (!res.ok) {
          throw new Error(`Error al obtener carpetas: ${res.status}`);
        }
        
        const data = await res.json();
        // Filtrar solo carpetas
        const foldersList = Array.isArray(data) 
          ? data.filter(item => item.type === 'directory' || item.isDirectory)
          : [];
        setFolders(foldersList);
      } catch (err) {
        console.error('Error en fetch:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchFolders();
  }, [expId, isOpen]);

  const handleFolderClick = (folder) => {
    setSelectedFolder(folder);
    setShowCreateNew(false);
  };

  const handleConfirm = () => {
    if (showCreateNew && newFolderName.trim()) {
      // Limpiar el nombre de carpeta
      const cleanName = newFolderName
        .trim()
        .replace(/[<>:"/\\|?*]/g, '_')
        .substring(0, 50);
      onFolderSelect(cleanName);
    } else if (selectedFolder) {
      onFolderSelect(selectedFolder.name);
    }
    handleClose();
  };

  const handleClose = () => {
    setSelectedFolder(null);
    setShowCreateNew(false);
    setNewFolderName("");
    setError(null);
    onClose();
  };

  const handleCreateNewClick = () => {
    setShowCreateNew(true);
    setSelectedFolder(null);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>Seleccionar carpeta para adjuntos</h3>
          <button className={styles.closeButton} onClick={handleClose}>
            <MyIcons name="close" width={24} height={24} color="black" />
          </button>
        </div>

        <div className={styles.modalContent}>
          {loading && <div className={styles.noFolders}>Cargando carpetas...</div>}
          {error && <div className={styles.noFolders}>Error: {error}</div>}
          
          {!loading && !error && (
            <>
              {folders.length > 0 ? (
                <div className={styles.foldersGrid}>
                  {folders.map((folder, index) => (
                    <div
                      key={index}
                      className={`${styles.folderCard} ${
                        selectedFolder?.name === folder.name ? styles.selected : ""
                      }`}
                      onClick={() => handleFolderClick(folder)}
                    >
                      <MyIcons
                        name="folder"
                        width={32}
                        height={32}
                        color={selectedFolder?.name === folder.name ? "white" : "var(--main)"}
                      />
                      <span className={styles.folderName}>{folder.name}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className={styles.noFolders}>No hay carpetas disponibles</div>
              )}

              <div className={styles.createNewSection}>
                {showCreateNew ? (
                  <div className={styles.newFolderInput}>
                    <Input
                      label="Nombre de la nueva carpeta"
                      placeholder="Nombre de carpeta"
                      value={newFolderName}
                      onChange={(e) => setNewFolderName(e.target.value)}
                      style={{ marginBottom: "16px" }}
                    />
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setShowCreateNew(false);
                        setNewFolderName("");
                      }}
                      style={{ width: "fit-content" }}
                    >
                      Cancelar
                    </Button>
                  </div>
                ) : (
                  <Button
                    variant="secondary"
                    onClick={handleCreateNewClick}
                    style={{ width: "fit-content" }}
                  >
                    Crear nueva carpeta
                  </Button>
                )}
              </div>
            </>
          )}
        </div>

        <div className={styles.modalFooter}>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={!selectedFolder && (!showCreateNew || !newFolderName.trim())}
          >
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FolderSelectorModal;
